(function () {
  'use strict';

  var blockedValues = { auto: true, none: true };
  var pendingStyles = new Set();

  function hasGlobalSelector(selectorText) {
    return String(selectorText || '')
      .split(',')
      .some(function (selector) { return selector.trim() === '*'; });
  }

  function sanitizeRuleList(ruleList) {
    if (!ruleList) return;

    for (var index = ruleList.length - 1; index >= 0; index -= 1) {
      var rule = ruleList[index];

      if (rule.cssRules) {
        sanitizeRuleList(rule.cssRules);
        continue;
      }

      if (!rule.style || !hasGlobalSelector(rule.selectorText)) continue;

      var value = rule.style.getPropertyValue('pointer-events').trim().toLowerCase();
      var priority = rule.style.getPropertyPriority('pointer-events').toLowerCase();

      if (priority === 'important' && blockedValues[value]) {
        rule.style.removeProperty('pointer-events');
      }
    }
  }

  function sanitizeStyle(styleElement) {
    if (!styleElement || styleElement.tagName !== 'STYLE') return;

    try {
      sanitizeRuleList(styleElement.sheet && styleElement.sheet.cssRules);
    } catch (error) {
      // Ignore stylesheets that the browser does not allow this page to inspect.
    }
  }

  function sanitizeDocument() {
    document.querySelectorAll('style').forEach(sanitizeStyle);
  }

  function queueStyle(styleElement) {
    if (!styleElement || styleElement.tagName !== 'STYLE') return;
    pendingStyles.add(styleElement);
    if (pendingStyles.size > 1) return;

    window.requestAnimationFrame(function () {
      var styles = Array.from(pendingStyles);
      pendingStyles.clear();
      styles.forEach(sanitizeStyle);
    });
  }

  function start() {
    sanitizeDocument();

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          queueStyle(mutation.target.parentElement);
          return;
        }

        if (mutation.target && mutation.target.nodeType === 1 && mutation.target.tagName === 'STYLE') {
          queueStyle(mutation.target);
        }

        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'STYLE') {
            queueStyle(node);
            return;
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('style').forEach(queueStyle);
          }
        });
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });

    window.addEventListener('load', sanitizeDocument, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
